import { createContext } from 'react';

import { Context } from '../../../types';
import { CreditCompany } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<CreditCompany>>(getContextDefaultValues(api));
